import { LayoutCarousel } from './layout-carousel';
import { LayoutComparisonTable } from './layout-comparison-table';
import { LayoutComparisonTableMobile } from './layout-comparison-table-mobile';
import { LayoutGrid } from './layout-grid';
import { LayoutTable } from './layout-table';

export const layoutsMap = {
  grid: LayoutGrid,
  table: LayoutTable,
  carousel: LayoutCarousel,
  comparisonTable: LayoutComparisonTable,
  comparisonTableMobile: LayoutComparisonTableMobile
};
